import { useSettingShowSideBarV2UI } from "@faire/retailer-visitor-shared/settings/useSettingShowSideBarV2UI";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React from "react";

export const SettingsSectionHeader = ({
  title,
  description,
}: {
  title: string;
  description?: React.ReactNode;
}) => {
  const { isTabletAndBelow } = useViewport();
  const showV2UI = useSettingShowSideBarV2UI();

  return (
    <Column>
      <Spacer size={isTabletAndBelow && showV2UI ? 16 : 20} />
      <Typography
        variant={{
          mobileAndAbove: "subheadingSansMedium",
          desktopAndAbove: "sectionHeaderSansMedium",
        }}
      >
        {title}
      </Typography>
      {description ? (
        <>
          <Spacer size={8} />
          <Typography>{description}</Typography>
        </>
      ) : null}
      <Spacer size={20} />
    </Column>
  );
};
